/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 */
function scrollStyle () {
  return `
    [data-v-scroll] {
        scrollbar-gutter: stable ; /*如果 overflow 属性计算值不是 visible，则提前预留好空白区域，这样滚动条出现的时候，整个结构和布局都是稳定的*/
    }
    [data-v-scroll]::-webkit-scrollbar {
        width: 9px;
        height: 9px;
        background: none;
    }
    [data-v-scroll-barBackground]::-webkit-scrollbar {
      background: #f5f6f9;
    }
    [data-v-scroll]::-webkit-scrollbar-thumb {
      width: 9px;
			height: 9px;
      border-radius: 5px;
      background-color: rgba(36, 47, 87, 0.2);
    }
    [data-v-scroll]::-webkit-scrollbar-thumb:hover {
      background-color: rgba(36, 47, 87, 0.3);
    }
  `
}

function createStyle () {
  const headDom = document.getElementsByTagName('head')[0]
  const oStyle = document.createElement('style')
  oStyle.className = 'fe-v-scrollbar-prettify '
  oStyle.innerHTML = scrollStyle()
  headDom.appendChild(oStyle)
}

const scrollbarPrettify = {
  bind (el, binding) {
    console.log(binding.modifiers)
    if(document.querySelectorAll('style.fe-v-scrollbar-prettify').length === 0) {
      createStyle()
    }
    el.setAttribute('data-v-scroll', '')
    binding.modifiers.barBackground && el.setAttribute('data-v-scroll-barBackground', '')
  }
}

export default scrollbarPrettify 
